import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import StripePaymentForm from './StripePaymentForm';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

export default function StripePaymentWrapper(props) {
  const { clientSecret } = props;

  if (!clientSecret) return null; // or loader

  return (
    <Elements
      stripe={stripePromise}
      options={{ clientSecret }}
    >
      <StripePaymentForm {...props} />
    </Elements>
  );
}